import { Component, EventEmitter, Input, OnDestroy, OnInit } from '@angular/core';
import { ISharpenModule, SharpenContentType } from '@shared/models/sharpen-data-model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sharpen-preview-card',
  templateUrl: './sharpen-preview-card.component.html',
  styleUrls: ['./sharpen-preview-card.component.scss']
})
export class SharpenPreviewCardComponent implements OnInit, OnDestroy {
  public types = SharpenContentType;

  public render: boolean = false;

  @Input() content: ISharpenModule;
  @Input() inCreationMode?: boolean;

  public openPreviewModal: EventEmitter<boolean> = new EventEmitter();

  private destroy$ = new Subject<void>();

  constructor() { }

  ngOnInit(): void {
    this.openPreviewModal.asObservable().pipe(takeUntil(this.destroy$)).subscribe((val) => {
      this.render = val
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
